import PricingHero from "./PricingHero";
import PricingIncluded from "./PricingIncluded";
import WhyNectr from "./WhyNectr";



function Pricing() {
    return (
        <>
            <PricingHero />
            <PricingIncluded />
            <WhyNectr />

        </>
    );
}

export default Pricing;